import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlGridTagNames, AtlGridThreeColsProps } from './grid.props';
import classNames from 'classnames';

@customElement(AtlGridTagNames.GridThreeCols)
export class AtlGridThreeCols
   extends LitElement
   implements AtlGridThreeColsProps
{
   declare internalId: string;
   declare internalClassName?: string;
   declare internalColClassName?: string;
   declare internalCol2ClassName?: string;
   declare internalCol3ClassName?: string;

   declare fullHeight?: boolean;

   static properties = {
      internalId: { type: String },
      internalClassName: { type: String },
      internalColClassName: { type: String },
      internalCol2ClassName: { type: String },
      internalCol3ClassName: { type: String },
      fullHeight: { attibute: 'full-height', type: Boolean },
   };

   protected override createRenderRoot() {
      return this;
   }

   override updated() {
      this.classList.value = `${classNames('row', 'grid-three-col', this.internalClassName, { 'h-100': this.fullHeight })}`;
   }
}
